import { Text } from "@radix-ui/themes";
import { twMerge } from "tailwind-merge";

type LegendToggleProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children: React.ReactNode;
  color: string;
};

export function LegendToggle({
  checked,
  onCheckedChange,
  children,
  color,
}: LegendToggleProps) {
  return (
    <Text
      as="div"
      className={twMerge([
        "flex items-center gap-2 opacity-50 hover:bg-[var(--gray-a4)] border border-[var(--gray-a4)] rounded-md px-2 py-1 cursor-pointer",
        checked && "opacity-100",
      ])}
      onClick={() => {
        onCheckedChange(!checked);
      }}
    >
      <div
        className={twMerge(["w-4 h-4"])}
        style={{ backgroundColor: color }}
      ></div>
      <Text className="select-none" size="2">
        {children}
      </Text>
    </Text>
  );
}
